
export default {
  data() {
    return {
      messageShown: false,
      showPassword: false,
      showConfirmedPassword: false,
    };
  },
  methods: {
    showMessage() {
      this.messageShown = true;
    },
    redirect() {
      this.$router.push({ path: this.$t("link.login") });
    },
  },
};
